/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateBriefWithSlugMutationVariables = Types.Exact<{
    slug: Types.Scalars['String'];
    designerIds?: Types.Maybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
    fields?: Types.Maybe<Types.Scalars['Map']>;
}>;

export type CreateBriefWithSlugMutation = {
    __typename: 'Mutation';
    brief: { __typename: 'StructuredBrief'; id: string };
};

export const CreateBriefWithSlugDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateBriefWithSlug' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'designerIds' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fields' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Map' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'createBriefWithSlug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'slug' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'designerIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'designerIds' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fields' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fields' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export type CreateBriefWithSlugMutationFn = Apollo.MutationFunction<
    CreateBriefWithSlugMutation,
    CreateBriefWithSlugMutationVariables
>;
export type CreateBriefWithSlugComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        CreateBriefWithSlugMutation,
        CreateBriefWithSlugMutationVariables
    >,
    'mutation'
>;

export const CreateBriefWithSlugComponent = (props: CreateBriefWithSlugComponentProps) => (
    <ApolloReactComponents.Mutation<
        CreateBriefWithSlugMutation,
        CreateBriefWithSlugMutationVariables
    >
        mutation={CreateBriefWithSlugDocument}
        {...props}
    />
);

/**
 * __useCreateBriefWithSlugMutation__
 *
 * To run a mutation, you first call `useCreateBriefWithSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBriefWithSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBriefWithSlugMutation, { data, loading, error }] = useCreateBriefWithSlugMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      designerIds: // value for 'designerIds'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateBriefWithSlugMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateBriefWithSlugMutation,
        CreateBriefWithSlugMutationVariables
    >
) {
    return Apollo.useMutation<CreateBriefWithSlugMutation, CreateBriefWithSlugMutationVariables>(
        CreateBriefWithSlugDocument,
        baseOptions
    );
}
export type CreateBriefWithSlugMutationHookResult = ReturnType<
    typeof useCreateBriefWithSlugMutation
>;
export type CreateBriefWithSlugMutationResult = Apollo.MutationResult<CreateBriefWithSlugMutation>;
export type CreateBriefWithSlugMutationOptions = Apollo.BaseMutationOptions<
    CreateBriefWithSlugMutation,
    CreateBriefWithSlugMutationVariables
>;
